const translations = {
  "en": {
    "Add to Home Screen": "Add to Home Screen",
    "In your Safari browser menu, tap the%{var0} icon and choose in the options": "In your Safari browser menu, tap the%{var0} icon and choose in the options",
    "To install the app, you need to add this website to": "To install the app, you need to add this website to",
    "your home screen.": "your home screen."
  },
  "zh-tw": {
    "Add to Home Screen": "加入主畫面",
    "In your Safari browser menu, tap the%{var0} icon and choose in the options": "在 Safari 瀏覽器選單中，點擊 %{var0} 圖示，並在選項中選擇",
    "To install the app, you need to add this website to": "要安裝此應用程式，你需要將此網站新增到",
    "your home screen.": "你的主畫面。"
  }
};

export default translations;
